import { CedeSDKError } from "./base";
import { SdkErrorCodes, SdkErrorMessages } from "./errorsMetadata";

/**
 * @description Thrown for internal errors
 */
export class InternalError extends CedeSDKError {
  constructor(code = SdkErrorCodes.INTERNAL_ERROR, message = SdkErrorMessages.INTERNAL_ERROR) {
    super(code, message);
    this.name = "InternalError";
  }
}

/**
 * @description Thrown when the exchange instance id is invalid and therefore the exchange instance is not found
 */
export class InvalidExchangeInstanceIdError extends InternalError {
  constructor(exchangeInstanceId: string) {
    super(
      SdkErrorCodes.INVALID_EXCHANGE_INSTANCE_ID,
      SdkErrorMessages.INVALID_EXCHANGE_INSTANCE_ID(exchangeInstanceId),
    );
    this.name = "InvalidExchangeInstanceIdError";
    this.notReportable = true;
  }
}

/**
 * @description Thrown when the exchange id is invalid and therefore the exchange is not found
 */
export class InvalidExchangeIdError extends InternalError {
  constructor(exchangeId: string) {
    super(SdkErrorCodes.INVALID_EXCHANGE_ID, SdkErrorMessages.INVALID_EXCHANGE_ID(exchangeId));
    this.name = "InvalidExchangeIdError";
  }
}
